export const regionList = [
    "Azerbaijan",
    "China",
    "Hong Kong",
    "Hungary",
    "India",
    "Individual Neutral Athletes",
    "Japan",
    "Jamaica",
    "Korea",
    "Lesotho",
    "Malaysia",
    "Mali",
    "New Zealand",
    "Pakistan",
    "Philippines",
    "Rwanda",
    "Saudi Arabia",
    "Singapore",
    "Sri Lanka",
    "Taiwan",
    "Thailand",
    "United Arab Emirates",
    "United States of America",
    "Vietnam",
];

const unsortedRegionTimezoneOffsetMap: { [key: string]: number | null } = {

    // 非洲
    "ALGERIA": 1,
    "ANGOLA": 1,
    "BENIN": 1,
    "BOTSWANA": 2,
    "BURKINA FASO": 0,
    "BURUNDI": 2,
    "CAMEROON": 1,
    "CAPE VERDE": -1,
    "CENTRAL AFRICAN REPUBLIC": 1,
    "CHAD": 1,
    "COMOROS": 3,
    "CONGO": 1,
    "CÔTE D'IVOIRE": 0,
    "DJIBOUTI": 3,
    "DEMOCRATIC REPUBLIC OF THE CONGO": 1, // 西部时区
    "EGYPT": 2,
    "EQUATORIAL GUINEA": 1,
    "ESWATINI": 2,
    "ETHIOPIA": 3,
    "GABON": 1,
    "GAMBIA": 0,
    "GHANA": 0,
    "GUINEA": 0,
    "GUINEA-BISSAU": 0,
    "KENYA": 3,
    "LESOTHO": 2,
    "LIBERIA": 0,
    "LIBYA": 2,
    "MADAGASCAR": 3,
    "MALAWI": 2,
    "MALI": 0,
    "MAURITANIA": 0,
    "MAURITIUS": 4,
    "MOROCCO": 1,
    "MOZAMBIQUE": 2,
    "NAMIBIA": 2,
    "NIGERIA": 1,
    "NIGER": 1,
    "RWANDA": 2,
    "SAO TOME AND PRINCIPE": 0,
    "SENEGAL": 0,
    "SEYCHELLES": 4,
    "SIERRA LEONE": 0,
    "SOMALIA": 3,
    "SOUTH AFRICA": 2,
    "SOUTH SUDAN": 2,
    "SUDAN": 2,
    "TOGO": 0,
    "TUNISIA": 1,
    "UGANDA": 3,
    "UNITED REPUBLIC OF TANZANIA": 3,
    "ZAMBIA": 2,
    "ZIMBABWE": 2,

    // 亚洲
    "AFGHANISTAN": 4.5,
    "BAHRAIN": 3,
    "BANGLADESH": 6,
    "BHUTAN": 6,
    "BRUNEI DARUSSALAM": 8,
    "CAMBODIA": 7,
    "CHINESE TAIPEI": 8,
    "HONG KONG, CHINA": 8,
    "INDIA": 5.5,
    "INDONESIA": 7, // 西部时区，多时区国家
    "IRAQ": 3,
    "ISLAMIC REPUBLIC OF IRAN": 3.5,
    "JAPAN": 9,
    "JORDAN": 3,
    "KAZAKHSTAN": 6, // 主要时区
    "KUWAIT": 3,
    "KYRGYZSTAN": 6,
    "LAO PEOPLE'S DEMOCRATIC REPUBLIC": 7,
    "LEBANON": 2,
    "MACAU, CHINA": 8,
    "MALAYSIA": 8,
    "MONGOLIA": 8,
    "MALDIVES": 5,
    "MYANMAR": 6.5,
    "NEPAL": 5.75,
    "OMAN": 4,
    "PAKISTAN": 5,
    "PALESTINE": 2,
    "PEOPLE'S REPUBLIC OF CHINA": 8,
    "PHILIPPINES": 8,
    "QATAR": 3,
    "REPUBLIC OF KOREA": 9,
    "SAUDI ARABIA": 3,
    "SINGAPORE": 8,
    "SRI LANKA": 5.5,
    "SYRIAN ARAB REPUBLIC": 3,
    "TAJIKISTAN": 5,
    "THAILAND": 7,
    "TIMOR-LESTE": 9,
    "TURKMENISTAN": 5,
    "UNITED ARAB EMIRATES": 4,
    "UZBEKISTAN": 5,
    "VIETNAM": 7,
    "YEMEN": 3,

    // 欧洲
    "ALBANIA": 1,
    "ANDORRA": 1,
    "ARMENIA": 4,
    "AUSTRIA": 1,
    "AZERBAIJAN": 4,
    "BELARUS": 3,
    "BELGIUM": 1,
    "BOSNIA AND HERZEGOVINA": 1,
    "BULGARIA": 2,
    "CROATIA": 1,
    "CYPRUS": 2,
    "CZECHIA": 1,
    "DENMARK": 1,
    "ESTONIA": 2,
    "FAROE ISLANDS": 0,
    "FINLAND": 2,
    "FRANCE": 1,
    "GEORGIA": 4,
    "GERMANY": 1,
    "GREAT BRITAIN": 0,
    "GREECE": 2,
    "HUNGARY": 1,
    "ICELAND": 0,
    "IRELAND": 0,
    "ISLE OF MAN": 0,
    "ISRAEL": 2,
    "ITALY": 1,
    "KOSOVO": 1,
    "LATVIA": 2,
    "LITHUANIA": 2,
    "LUXEMBOURG": 1,
    "MALTA": 1,
    "MONACO": 1,
    "MONTENEGRO": 1,
    "NETHERLANDS": 1,
    "NORTH MACEDONIA": 1,
    "NORWAY": 1,
    "PORTUGAL": 0,
    "POLAND": 1,
    "REPUBLIC OF MOLDOVA": 2,
    "ROMANIA": 2,
    "RUSSIAN FEDERATION": 3, // 莫斯科时区，多时区国家
    "SAN MARINO": 1,
    "SERBIA": 1,
    "SLOVAKIA": 1,
    "SLOVENIA": 1,
    "SPAIN": 1,
    "SWEDEN": 1,
    "SWITZERLAND": 1,
    "TÜRKIYE": 3,
    "UKRAINE": 2,
    "VATICAN CITY": 1,

    // 大洋洲
    "AMERICAN SAMOA": -11,
    "AUSTRALIA": 10, // 东部时区，多时区国家
    "COOK ISLANDS": -10,
    "FEDERATED STATES OF MICRONESIA": 10, // 主要时区
    "FIJI": 12,
    "FRENCH POLYNESIA": -10,
    "GUAM": 10,
    "KIRIBATI": 12, // 主要时区
    "MARSHALL ISLANDS": 12,
    "NAURU": 12,
    "NEW CALEDONIA": 11,
    "NEW ZEALAND": 12,
    "PALAU": 9,
    "PAPUA NEW GUINEA": 10,
    "SAMOA": 13,
    "SOLOMON ISLANDS": 11,
    "TONGA": 13,
    "TUVALU": 12,
    "VANUATU": 11,

    // 美洲
    "ANTIGUA AND BARBUDA": -4,
    "ARGENTINA": -3,
    "ARUBA": -4,
    "BAHAMAS": -5,
    "BARBADOS": -4,
    "BELIZE": -6,
    "BERMUDA": -4,
    "BOLIVIA": -4,
    "BRAZIL": -3, // 主要时区，多时区国家
    "CANADA": -5, // 东部时区，多时区国家
    "CAYMAN ISLANDS": -5,
    "CHILE": -4,
    "COLOMBIA": -5,
    "COSTA RICA": -6,
    "CUBA": -5,
    "CURACAO": -4,
    "DOMINICAN REPUBLIC": -4,
    "DOMINICA": -4,
    "ECUADOR": -5,
    "FRENCH GUIANA": -3,
    "GRENADA": -4,
    "GUADELOUPE": -4,
    "GUATEMALA": -6,
    "GUYANA": -4,
    "HAITI": -5,
    "HONDURAS": -6,
    "JAMAICA": -5,
    "MARTINIQUE": -4,
    "MEXICO": -6, // 中部时区，多时区国家
    "EL SALVADOR": -6,
    "NICARAGUA": -6,
    "PANAMA": -5,
    "PARAGUAY": -3,
    "PERU": -5,
    "PUERTO RICO": -4,
    "SAINT KITTS AND NEVIS": -4,
    "SAINT LUCIA": -4,
    "SAINT VINCENT AND THE GRENADINES": -4,
    "SURINAME": -3,
    "TRINIDAD AND TOBAGO": -4,
    "UNITED STATES OF AMERICA": -5, // 东部时区，多时区国家
    "URUGUAY": -3,
    "VENEZUELA": -4,
    "VIRGIN ISLANDS, BRITISH": -4,
    "VIRGIN ISLANDS, US": -4
};

const sortedRegionTimezoneOffsetMapEntries = Object.entries(unsortedRegionTimezoneOffsetMap).sort(([keyA], [keyB]) =>
  keyA.localeCompare(keyB)
);

export const regionTimezoneOffsetMap = Object.fromEntries(sortedRegionTimezoneOffsetMapEntries);

export const unsortedNOCNameMap: { [key: string]: string | null } = {
	"ALGERIA": "ALG",
	"ANGOLA": "ANG",
	"BENIN": "BEN",
	"BOTSWANA": "BOT",
	"BURKINA FASO": "BUR",
	"BURUNDI": "BDI",
	"CAMEROON": "CMR",
	"CAPE VERDE": "CPV",
	"CENTRAL AFRICAN REPUBLIC": "CAF",
	"CHAD": "CHA",
	"COMOROS": "COM",
	"CONGO": "CGO",
	"CÔTE D'IVOIRE": "CIV",
	"DJIBOUTI": "DJI",
	"DEMOCRATIC REPUBLIC OF THE CONGO": "COD",
	"EGYPT": "EGY",
	"EQUATORIAL GUINEA": "GEQ",
	"ESWATINI": "SWZ",
	"ETHIOPIA": "ETH",
	"GABON": "GAB",
	"GAMBIA": "GAM",
	"GHANA": "GHA",
	"GUINEA": "GUI",
	"GUINEA-BISSAU": "GBS",
	"KENYA": "KEN",
	"LESOTHO": "LES",
	"LIBERIA": "LBR",
	"LIBYA": "LBA",
	"MADAGASCAR": "MAD",
	"MALAWI": "MAW",
	"MALI": "MLI",
	"MAURITANIA": "MTN",
	"MAURITIUS": "MRI",
	"MOROCCO": "MAR",
	"MOZAMBIQUE": "MOZ",
	"NAMIBIA": "NAM",
	"NIGERIA": "NGR",
	"NIGER": "NIG",
	"RWANDA": "RWA",
	"SAO TOME AND PRINCIPE": "STP",
	"SENEGAL": "SEN",
	"SEYCHELLES": "SYC",
	"SIERRA LEONE": "SLE",
	"SOMALIA": "SOM",
	"SOUTH AFRICA": "RSA",
	"SOUTH SUDAN": "SSD",
	"SUDAN": "SUD",
	"TOGO": "TOG",
	"TUNISIA": "TUN",
	"UGANDA": "UGA",
	"UNITED REPUBLIC OF TANZANIA": "TAN",
	"ZAMBIA": "ZAM",
	"ZIMBABWE": "ZIM",
	"AFGHANISTAN": "AFG",
	"BAHRAIN": "BRN",
	"BANGLADESH": "BAN",
	"BHUTAN": "BHU",
	"BRUNEI DARUSSALAM": "BRU",
	"CAMBODIA": "CAM",
	"CHINESE TAIPEI": "TPE",
	"HONG KONG, CHINA": "HKG",
	"INDIA": "IND",
	"INDONESIA": "INA",
	"IRAQ": "IRQ",
	"ISLAMIC REPUBLIC OF IRAN": "IRI",
	"JAPAN": "JPN",
	"JORDAN": "JOR",
	"KAZAKHSTAN": "KAZ",
	"KUWAIT": "KUW",
	"KYRGYZSTAN": "KGZ",
	"LAO PEOPLE'S DEMOCRATIC REPUBLIC": "LAO",
	"LEBANON": "LBN",
	"MACAU, CHINA": "MAC",
	"MALAYSIA": "MAS",
	"MONGOLIA": "MGL",
	"MALDIVES": "MDV",
	"MYANMAR": "MYA",
	"NEPAL": "NEP",
	"OMAN": "OMA",
	"PAKISTAN": "PAK",
	"PALESTINE": "PLE",
	"PEOPLE'S REPUBLIC OF CHINA": "CHN",
	"PHILIPPINES": "PHI",
	"QATAR": "QAT",
	"REPUBLIC OF KOREA": "KOR",
	"SAUDI ARABIA": "KSA",
	"SINGAPORE": "SGP",
	"SRI LANKA": "SRI",
	"SYRIAN ARAB REPUBLIC": "SYR",
	"TAJIKISTAN": "TJK",
	"THAILAND": "THA",
	"TIMOR-LESTE": "TLS",
	"TURKMENISTAN": "TKM",
	"UNITED ARAB EMIRATES": "UAE",
	"UZBEKISTAN": "UZB",
	"VIETNAM": "VIE",
	"YEMEN": "YEM",
	"ALBANIA": "ALB",
	"ANDORRA": "AND",
	"ARMENIA": "ARM",
	"AUSTRIA": "AUT",
	"AZERBAIJAN": "AZE",
	"BELARUS": "BLR",
	"BELGIUM": "BEL",
	"BOSNIA AND HERZEGOVINA": "BIH",
	"BULGARIA": "BUL",
	"CROATIA": "CRO",
	"CYPRUS": "CYP",
	"CZECHIA": "CZE",
	"DENMARK": "DEN",
	"ESTONIA": "EST",
	"FAROE ISLANDS": "FRO",
	"FINLAND": "FIN",
	"FRANCE": "FRA",
	"GEORGIA": "GEO",
	"GERMANY": "GER",
	"GREAT BRITAIN": "GBR",
	"GREECE": "GRE",
	"HUNGARY": "HUN",
	"ICELAND": "ISL",
	"IRELAND": "IRL",
	"ISLE OF MAN": "IMN",
	"ISRAEL": "ISR",
	"ITALY": "ITA",
	"KOSOVO": "KOS",
	"LATVIA": "LAT",
	"LITHUANIA": "LTU",
	"LUXEMBOURG": "LUX",
	"MALTA": "MLT",
	"MONACO": "MON",
	"MONTENEGRO": "MNE",
	"NETHERLANDS": "NED",
	"NORTH MACEDONIA": "MKD",
	"NORWAY": "NOR",
	"PORTUGAL": "POR",
	"POLAND": "POL",
	"REPUBLIC OF MOLDOVA": "MDA",
	"ROMANIA": "ROU",
	"RUSSIAN FEDERATION": "RUS",
	"SAN MARINO": "SMR",
	"SERBIA": "SRB",
	"SLOVAKIA": "SVK",
	"SLOVENIA": "SLO",
	"SPAIN": "ESP",
	"SWEDEN": "SWE",
	"SWITZERLAND": "SUI",
	"TÜRKIYE": "TUR",
	"UKRAINE": "UKR",
	"VATICAN CITY": "VAT",
	"AMERICAN SAMOA": "ASA",
	"AUSTRALIA": "AUS",
	"COOK ISLANDS": "COK",
	"FEDERATED STATES OF MICRONESIA": "FSM",
	"FIJI": "FIJ",
	"FRENCH POLYNESIA": "FPO",
	"GUAM": "GUM",
	"KIRIBATI": "KIR",
	"MARSHALL ISLANDS": "MHL",
	"NAURU": "NRU",
	"NEW CALEDONIA": "NCD",
	"NEW ZEALAND": "NZL",
	"PALAU": "PLW",
	"PAPUA NEW GUINEA": "PNG",
	"SAMOA": "SAM",
	"SOLOMON ISLANDS": "SOL",
	"TONGA": "TGA",
	"TUVALU": "TUV",
	"VANUATU": "VAN",
	"ANTIGUA AND BARBUDA": "ANT",
	"ARGENTINA": "ARG",
	"ARUBA": "ARU",
	"BAHAMAS": "BAH",
	"BARBADOS": "BAR",
	"BELIZE": "BIZ",
	"BERMUDA": "BER",
	"BOLIVIA": "BOL",
	"BRAZIL": "BRA",
	"CANADA": "CAN",
	"CAYMAN ISLANDS": "CAY",
	"CHILE": "CHI",
	"COLOMBIA": "COL",
	"COSTA RICA": "CRC",
	"CUBA": "CUB",
	"CURACAO": "CAO",
	"DOMINICAN REPUBLIC": "DOM",
	"DOMINICA": "DMA",
	"ECUADOR": "ECU",
	"FRENCH GUIANA": "FGT",
	"GRENADA": "GRN",
	"GUADELOUPE": "GDL",
	"GUATEMALA": "GUA",
	"GUYANA": "GUY",
	"HAITI": "HAI",
	"HONDURAS": "HON",
	"JAMAICA": "JAM",
	"MARTINIQUE": "MRN",
	"MEXICO": "MEX",
	"EL SALVADOR": "ESA",
	"NICARAGUA": "NCA",
	"PANAMA": "PAN",
	"PARAGUAY": "PAR",
	"PERU": "PER",
	"PUERTO RICO": "PUR",
	"SAINT KITTS AND NEVIS": "SKN",
	"SAINT LUCIA": "LCA",
	"SAINT VINCENT AND THE GRENADINES": "VIN",
	"SURINAME": "SUR",
	"TRINIDAD AND TOBAGO": "TTO",
	"UNITED STATES OF AMERICA": "USA",
	"URUGUAY": "URU",
	"VENEZUELA": "VEN",
	"VIRGIN ISLANDS, BRITISH": "IVB",
	"VIRGIN ISLANDS, US": "ISV"
};

const sortedNOCNameMapEntries = Object.entries(unsortedNOCNameMap).sort(([keyA], [keyB]) =>
  keyA.localeCompare(keyB)
);
export const NOCNameMap = Object.fromEntries(sortedNOCNameMapEntries);
